import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Link,
  Typography,
  makeStyles,
} from '@material-ui/core';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const PrivacyPolicyView = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Privacy Policy">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Typography color="textPrimary" variant="h2" gutterBottom>
            Privacy Policy
          </Typography>
          <Typography color="textSecondary" variant="body1" gutterBottom>
            This page is under construction. Please check back soon.
          </Typography>
          <Typography color="textSecondary" variant="body1" gutterBottom>
            {'For privacy inquiries, please contact us at '}
            <Link href="mailto:privacy@xounter.com">privacy@xounter.com</Link>
            .
          </Typography>
          <Box mt={2}>
            <Link component={RouterLink} to="/app/login" variant="body1">
              Back to Login
            </Link>
          </Box>
        </Container>
      </Box>
    </Page>
  );
};

export default PrivacyPolicyView;
